import { Box, Flex, Text } from '@mantine/core';
import { IconFileText, IconFileTextSpark, IconFolder } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import RenameDocumentControl from 'src/data-capture/file-management/components/RenameDocumentControl';
import { formatFileSize } from 'src/utils/fileSizeFormatting';

type Props = {
  fileName: string;
  fileSize?: number;
  subtitle?: string;
  isFolder: boolean;
  isGenerated: boolean;
  renameFileId?: number;
};

export default function FileNameWithIcon({
  fileName,
  fileSize,
  subtitle,
  isFolder,
  isGenerated,
  renameFileId,
}: Props) {
  const secondaryLine = subtitle ?? (fileSize != null ? humanFileSize(fileSize) : null);

  return (
    <Flex wrap={'nowrap'} gap={'xs'} align="center">
      <Flex bg="gray.1" w={40} h={40} align="center" justify="center" style={{ borderRadius: 20 }}>
        <FileIcon isFolder={isFolder} isGenerated={isGenerated} />
      </Flex>
      <Box>
        <Text fw={FONT_WEIGHTS.medium} size="textSm" c="gray.10">
          {fileName}
        </Text>
        {secondaryLine && (
          <Text fw={500} size="sm" c="gray.7">
            {secondaryLine}
          </Text>
        )}
      </Box>
      {renameFileId !== undefined && (
        <RenameDocumentControl fileId={renameFileId} currentName={fileName} />
      )}
    </Flex>
  );
}

function FileIcon({ isFolder, isGenerated }: { isFolder: boolean; isGenerated: boolean }) {
  if (isFolder) {
    return <IconFolder size={20} />;
  }
  if (isGenerated) {
    return <IconFileTextSpark size={20} />;
  }
  return <IconFileText size={20} />;
}

function humanFileSize(size: number | null | undefined) {
  return size ? formatFileSize(size) : '';
}
